<template>
  <v-row class="">
    <v-col cols="12" class="pa-0 mb-1 elevation-1" v-for="(item, i) in cart" :key="'item'+i">
      <v-row class="">
        <v-col cols="3">
          <img :src="item.image.url" width="100%">
        </v-col>
        <v-col cols="4" :class="`${arabic?'arFont':'enFont'} primary--text`" style="font-size:12px;">
          {{item['name_'+language]}}
        </v-col>
        <v-col cols="3">
          <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;">{{ i18n["price"] }}: {{item.price.toFixed(2)}} {{currency_symbol}}</div>
          <div :class="`${arabic?'arFont':'enFont'} success--text`" style="font-size:11px;" v-if="item.user_profit">{{ i18n["profit"] }}: {{item.user_profit.toFixed(2)}} {{currency_symbol}}</div>
        </v-col>
        <v-col cols="2">
          <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;">{{item.total.toFixed(2)}} {{currency_symbol}}</div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <span :class="`${arabic?'arFont':'enFont'}`">{{ i18n.order_total }}: {{ cart_total.toFixed(2) }} {{currency_symbol}}</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props:[],
  components: {  },
  data(){
    return {
      dialog:false,
      dialog2:false,
      dialog3:false,
      lead:null,
      rating:0,
      
    }
  },
  methods:{
    clipboardSuccessHandler ({ value, event }){
      this.$emit('clipboardSuccessHandler', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('clipboardSuccessHandler', { value, event })
    },
  },
  computed:{
    cart_total(){
      return this.$store.state.cart_total
    },
    currency_symbol(){
      return this.$store.state.currency_symbol
    },
    cart(){
      return this.$store.state.cart
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>

<style>

</style>